import type { Transition, Variants } from 'framer-motion'

export const notchResizeTransition: Transition = { type: 'spring', bounce: 0.1, duration: 0.35 }
export const notchToastEnterTransition: Transition = { type: 'spring', bounce: 0.2, duration: 0.55 }
export const notchCollapseTransition: Transition = { type: 'spring', bounce: 0, duration: 0.45 }

export const notchEaseOut: Transition['ease'] = [0.22, 1, 0.36, 1]

/**
 * The left list is placed by its outer edge, so content appearing at its notch end starts behind the notch and
 * rides out on the resize spring. Fading in across that slide keeps it faint until it's clear.
 */
export const notchEmergeFadeTransition: Transition = { duration: 0.3, ease: 'easeInOut' }

export const notchLayerVariants: Variants = {
  hidden: { opacity: 0, filter: 'blur(3px)', transition: { duration: 0.14, ease: 'easeOut' } },
  visible: { opacity: 1, filter: 'blur(0px)', transition: { duration: 0.3, delay: 0.08, ease: notchEaseOut } },
}

export const notchToastLayerVariants: Variants = {
  hidden: { opacity: 0, y: -6, filter: 'blur(4px)', transition: { duration: 0.14, ease: 'easeOut' } },
  visible: { opacity: 1, y: 0, filter: 'blur(0px)', transition: { duration: 0.34, delay: 0.1, ease: notchEaseOut } },
}

export const notchCrossfadeVariants: Variants = {
  hidden: { opacity: 0, filter: 'blur(3px)' },
  visible: { opacity: 1, filter: 'blur(0px)' },
}

export const notchCrossfadeTransition: Transition = { duration: 0.28, ease: notchEaseOut }
